var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 5120 5120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l10KzM7ITvrJjFOMlb7zHGV",
    fill: "#f58220",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f58220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pp2yIFipR",
    d: "M2410 5108 c-882 -43 -1699 -573 -2114 -1368 -197 -379 -287 -747 -287 -1180 0 -427 85 -782 278 -1162 346 -683 1014 -1191 1763 -1342 327 -66 731 -64 1045 5 753 165 1394 659 1739 1339 192 378 277 734 277 1160 0 420 -82 770 -268 1142 -241 481 -626 873 -1104 1122 -417 218 -842 309 -1329 284z m-180 -1254 c189 -28 401 -94 565 -176 467 -235 826 -676 978 -1203 49 -170 68 -287 74 -467 l6 -156 46 -35 c66 -51 210 -200 186 -193 -55 15 -157 36 -212 42 l-63 7 0 -35 c0 -30 8 -40 63 -84 54 -43 172 -182 163 -191 -2 -2 -39 10 -82 28 -91 36 -214 69 -256 69 -22 0 -46 -14 -86 -51 -123 -109 -339 -181 -479 -159 -285 46 -499 242 -564 518 -18 74 -20 104 -14 200 l7 112 -24 0 c-69 0 -256 -24 -354 -46 -357 -79 -663 -245 -932 -507 -61 -61 -114 -108 -116 -106 -24 28 -66 191 -66 260 0 61 33 189 69 264 39 83 111 177 170 222 44 34 50 42 50 76 l1 39 -77 -7 c-69 -7 -113 -16 -191 -40 -21 -7 -23 -5 -17 21 17 75 50 165 81 221 75 134 226 259 369 304 72 23 75 25 75 55 0 41 -9 45 -152 51 l-118 6 26 47 c63 116 173 219 299 280 77 37 195 70 249 70 23 0 26 4 26 34 0 29 -7 39 -49 70 -183 135 -460 229 -714 245 l-112 6 60 31 c196 101 459 173 730 198 67 6 284 -5 385 -20z",
    fill: "#f58220"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lWL1huOQmahOUaW38wJs7S",
    fill: "#FFFFFF",
    style: {
      transform: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p15SMcO4ZE",
    d: "M1805 3904 c-186 -15 -428 -73 -599 -143 -78 -32 -296 -145 -296 -154 0 -1 75 -2 168 -2 137 0 186 -5 272 -24 174 -38 379 -127 504 -219 47 -34 49 -37 26 -40 -197 -22 -370 -112 -486 -253 -42 -51 -114 -179 -114 -203 0 -7 38 -11 118 -11 64 0 130 -4 146 -8 27 -8 24 -10 -51 -36 -214 -74 -384 -261 -437 -482 -20 -81 -22 -163 -4 -156 108 45 147 58 207 65 39 5 71 6 70 3 0 -3 -23 -23 -50 -44 -135 -103 -239 -327 -239 -516 0 -90 29 -221 65 -291 l26 -51 106 111 c187 196 365 322 606 431 174 79 394 140 552 154 39 3 84 8 101 11 l31 4 -4 -112 c-4 -92 -1 -129 16 -200 70 -294 308 -496 616 -524 154 -13 368 59 486 165 l57 51 73 -19 c84 -22 201 -67 290 -112 60 -30 61 -30 54 -7 -14 43 -53 113 -98 174 -40 55 -72 86 -157 153 l-25 19 30 -5 c87 -13 189 -39 259 -64 43 -16 81 -28 83 -25 14 14 -229 274 -299 320 -25 16 -25 20 -31 174 -6 180 -25 297 -74 467 -152 527 -511 968 -978 1203 -165 82 -375 148 -570 177 -102 15 -360 26 -450 19z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dfe5fba7b353c9e12b4b537a4a59bc7a.svg";
export { ForwardRef as ReactComponent };